"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const configTypes_1 = require("./configTypes");
const cloudProvider_1 = __importDefault(
  require("workflow-model/dist/types/cloudProvider")
);
exports.getAccountConfig = (configs = []) => {
  if (!configs) return [];
  return configs.filter(
    u =>
      u.type === configTypes_1.CONFIG_TYPES.AWS_KEY ||
      u.type === configTypes_1.CONFIG_TYPES.AWS_ROLE ||
      u.type === configTypes_1.CONFIG_TYPES.AWS_PROXY ||
      u.type === configTypes_1.CONFIG_TYPES.AWS_ORG_MEMBER ||
      u.type === configTypes_1.CONFIG_TYPES.AZURE ||
      u.type === configTypes_1.CONFIG_TYPES.VMWARE ||
      u.type === configTypes_1.CONFIG_TYPES.Kubernetes
  );
};
exports.groupAccountConfigsOptions = configs => {
  let accountConfigs = exports.getAccountConfig(configs);
  if (accountConfigs.length === 0) return [];
  let awsOrgsMap = {};
  let awsAccounts = [];
  let azureAccounts = [];
  let vmwareAccounts = [];
  let k8Accounts = [];
  let otherAccountGroupMap = {};
  const typeMap = {
    [configTypes_1.CONFIG_TYPES.AWS_PROXY]: [
      cloudProvider_1.default.AWS,
      awsAccounts
    ],
    [configTypes_1.CONFIG_TYPES.AWS_KEY]: [
      cloudProvider_1.default.AWS,
      awsAccounts
    ],
    [configTypes_1.CONFIG_TYPES.AWS_ROLE]: [
      cloudProvider_1.default.AWS,
      awsAccounts
    ],
    [configTypes_1.CONFIG_TYPES.AZURE]: [
      cloudProvider_1.default.AZURE,
      azureAccounts
    ],
    [configTypes_1.CONFIG_TYPES.VMWARE]: [
      cloudProvider_1.default.VMWARE,
      vmwareAccounts
    ],
    [configTypes_1.CONFIG_TYPES.Kubernetes]: [
      cloudProvider_1.default.Kubernetes,
      k8Accounts
    ]
  };
  for (let cfg of accountConfigs) {
    const { type, id, name, parentName } = cfg;
    if (parentName && type === configTypes_1.CONFIG_TYPES.AWS_ORG_MEMBER) {
      awsOrgsMap[parentName] = (awsOrgsMap[parentName] || []).concat({
        label: name,
        value: id,
        type: cloudProvider_1.default.AWS
      });
    } else if (parentName) {
      otherAccountGroupMap[parentName] = (
        otherAccountGroupMap[parentName] || []
      ).concat({
        label: cfg.name,
        value: cfg.id,
        type: typeMap[type][0]
      });
    } else if (typeMap[type]) {
      const [cloudProvider, configGroup] = typeMap[type];
      configGroup.push({
        label: cfg.name,
        value: cfg.id,
        type: cloudProvider
      });
    }
  }
  return [
    {
      label: "AWS Accounts",
      options: awsAccounts
    },
    {
      label: "AWS Organisation",
      options: Object.keys(awsOrgsMap).map(x => {
        return { label: x, value: x, options: awsOrgsMap[x] };
      })
    },
    {
      label: "Azure Accounts",
      options: azureAccounts
    },
    {
      label: "Groups",
      options: Object.keys(otherAccountGroupMap).map(x => {
        return { label: x, value: x, options: otherAccountGroupMap[x] };
      })
    },
    {
      label: "VMware Accounts",
      options: vmwareAccounts
    },
    {
      label: "Kubernetes Accounts",
      options: k8Accounts
    }
  ];
};
//# sourceMappingURL=accountsConfigHelpers.js.map
